import { useState } from "react";
import EnvelopeIcon from "../../assets/svg/envelopeIcon";
import LogoIcon from "../../assets/svg/logoIcon";
import createAxiosInstance from "../../utils/axiosConfig";
import Alert from "../common/alerts/alert";
import Footer from "../common/footer";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
	const [alertVisible, setAlertVisible] = useState(false);
	const [submitted, setSubmitted] = useState(false);
	const [email, setEmail] = useState("");
	const [error, setError] = useState("");

	const navigate = useNavigate();
	
	const handleSubmit = async (e: any) => {
		e.preventDefault();

		const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
		if (!emailPattern.test(email)) {
			setError("Please enter a valid email address.");
			return;
		}

		try {
			const axiosInstance = createAxiosInstance();

			const response = await axiosInstance.post("/request-password-reset", {
				email,
			});

			if (response.status === 200) {
				setSubmitted(true);
				setError("");
			} else {
				setError("Failed to send reset password email. Please try again.");
				setAlertVisible(true);
			}
		} catch (error) {
			setError("An error occurred. Please try again.");
			setAlertVisible(true);
		}
	};

	return (
		<section className="authentication min-vh-100">
			<header className="p-4">
				<div className="container-fluid">
					<div className="card d-flex align-items-center" style={{
						width: '6%',
					}}>
						<LogoIcon />
					</div>
				</div>
			</header>
			<div className="row align-items-center min-vh-75 w-100">
				<div className="col-md-12 col-lg-12 col-xl-12">
					
					<div className="w-32" style={{
						marginLeft: '12%'
					}}>
						<div className="mb-3">
							{/* <LogoIcon /> */}
						</div>
						{submitted ? (
							<div className="text-white">
								<h2 className="my-3 my-md-4 text-white">Help is on the way</h2>
								<p className="text-white">
									We're combing through our records to find the 1Ciso account
									for:
									<a href="" className="text-white px-1" style={{
										fontWeight: 'bold',
										textDecoration: 'underline',
									}}>{email}</a>
								</p>
								<p>
									If we find a match, you’ll get an email with further
									instructions. If you don’t hear from us in the next 15
									minutes, please double check that you entered the correct
									email address and check your spam folder.
								</p>
								<div className="mb-3 text-white">
									<a href="/" type="submit" className="btn btn-link w-100 text-white">
										<i className="bi bi-arrow-left me-2"></i> Go Back
									</a>
								</div>
							</div>
						) : (
							<>
								<h2 className="text-white my-3 my-md-4">Forgot Password?</h2>
								{/* <p className="text-white">
									Enter your email to reset your password.
								</p> */}
								<form onSubmit={handleSubmit}>
									<div className="">
										<label htmlFor="email" className="form-label text-white mb-2">
											Please enter your email address
										</label>
										<input
											type="email"
											className="form-control form-control-lg bg-white rounded-4"
											id="email"
											// placeholder="name@example.com"
											name="email"
											value={email}
											onChange={(e) => setEmail(e.target.value)}
											required
										/>
										
									</div>
									<div className="mt-5 d-flex flex-row flex-grow-1 gap-3 align-items-center">
										<div className="d-grid w-35 gap-2">
											<button 
												type="submit" 
												className="w-100 btn btn-sm btn-rounded btn-secondary text-white fw-bold py-3"
												// disabled={Object.keys(errors).length > 0}
												style={{
													// borderRadius: '10px',
													background: '#26397E',
													borderRadius: "77.125rem"
												}}
											>
												SUBMIT
											</button>
										</div>
										<div className=" text-white text-center">
											Have a password? <a href="/signup" className="text-white fw-bold"><u>SIGN IN</u></a>
										</div>
									</div>
									<p className="text-secondary">{error}</p>
									{/* <div className="mb-3">
										<a href="/" className="btn btn-link w-100">
											<i className="bi bi-arrow-left me-2"></i> Back
										</a>
									</div> */}
								</form>
								
								<Alert
									message={`${
										error.length > 1
											? error
											: "Reset password requested successfuly."
									}`}
									type={`${error.length > 1 ? "danger" : "success"}`}
									show={alertVisible}
									onClose={() => setAlertVisible(false)}
								/>
							</>
						)}
					</div>
					
				</div>
			</div>
			<div className="row">
									<div className="d-flex justify-content-end" style={{
										marginRight: '10%',
										paddingRight: '3%',
										marginTop: '1%'
									}}>
										<div className="text-white my-2 px-3">
											Powered By: 
										</div>
										<div className="card d-flex align-items-center" style={{
												width: '6%',
											}}>
												<LogoIcon />
										</div>
									</div>
								</div>
								<div className="d-flex flex-row gap-2" style={{
									marginLeft: '12%',
									marginTop: '1%',
									color: 'white'
								}}>
									Some information about the platform:
									<ul style={{
										listStyleType: 'none',
										paddingLeft: '0',
										marginLeft: '0',
										display: 'flex',
										flexDirection: 'row',
										gap: '10',
										color: 'white'
									}}>
										<li style={{borderRight: '1px solid white', paddingRight: '10px', textDecoration: 'underline', cursor: 'pointer'}} onClick={() => navigate("/terms-and-conditions")}> Terms & conditions </li>
										<li style={{borderRight: '1px solid white', paddingRight: '10px', textDecoration: 'underline', paddingLeft: '10px', cursor: 'pointer'}} onClick={() => navigate("/privacy-policy")}>Privacy Policy</li>
										<li style={{cursor: 'pointer', paddingLeft: '10px', textDecoration: 'underline'}} onClick={() => navigate("/disclaimer")}>Disclaimer</li>
									</ul>
								</div>
		</section>
	);
};

export default ForgotPassword;
